import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { PlanningComponent } from './components/planning/planning.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ChooseClubComponent } from './components/choose-club/choose-club.component';
import { AuthComponent } from './components/auth/auth.component';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ClockComponent } from './components/clock/clock.component';
import { CoachPickerComponent } from './components/coach-picker/coach-picker.component';
import { WsService } from './services/ws/ws.service';
import { AppRoutingModule } from './app.routing.module';
import { AppBaseComponent } from './app-base/app-base.component';
import { NotLoggedGuard } from './guards/not-logged.guard';
import { LoggedRouteGuard } from './guards/logged-route.guard';
import { SessionService } from './services/session.service';
import { SelectedClubService } from './services/selected-club.service';
import { ConnectedUserComponent } from './components/connected-user/connected-user.component';
import { HighlightsComponent } from './components/highlights/highlights.component';
import { BookComponent } from './components/book/book.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { ToastrModule } from 'ngx-toastr';
import { DataService } from './services/data.service';
import { ApiassetPipe } from './pipes/apiasset.pipe';
import { TranslatePipe } from './pipes/translate.pipe';
import { DefaultAssetPipe } from './pipes/default-asset.pipe';
import { TimePipe } from './pipes/time.pipe';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { SprintfPipe } from './pipes/sprintf.pipe';
import { ActiveBookingListComponent } from './components/active-booking-list/active-booking-list.component';
import { DataBootstrapGuard } from './guards/data-bootstrap.guard';
import localeFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';
import { ActiveBookingBadgeComponent } from './components/active-booking-badge/active-booking-badge.component';
import { KeyboardDirective } from './directives/keyboard.directive';
import { WelcomeDialogComponent } from './components/welcome-dialog/welcome-dialog.component';
import { WsHttpInterceptor } from './interceptors/ws-http.interceptor';
import { SocketClientService } from './services/socket-client.service';
import { SessionPrepareService } from './services/session-prepare.service';
import { ErrorDialogService } from './services/error-dialog.service';
import { SpinnerMessageService } from './services/spinner-message.service';
import { CrashMessageService } from './services/crash-message.service';
import { LogoutService } from './services/logout.service';
import { InteractionService } from './services/interaction.service';
import { InactivityProgressBarComponent } from './components/inactivity-progress-bar/inactivity-progress-bar.component';
import { BootstrapSessionService } from './services/bootstrap-session';
import { DisconnectedComponent } from './components/disconnected/disconnected.component';
import { AppFooterComponent } from './components/app-footer/app-footer.component';
import { CrashComponent } from './components/crash/crash.component';
import { LangChangerComponent } from './lang-changer/lang-changer.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TopbarComponent } from './topbar/topbar.component';
import { ClickOutsideModule } from 'ng-click-outside';
registerLocaleData(localeFr, window.app.lang._.ng);

/**
 * Note: TVScreen app doesn't create a socket connection.
 * Since there's no connections involved.
 */
const nonTvScreenService = [
     // List of services provided only for non tv apps.
     SocketClientService,
     InteractionService,
];
if (window.app.tvScreen) {
     nonTvScreenService.splice(0, 1);
}

@NgModule({
     declarations: [
          /*Components*/
          AppComponent,
          TopbarComponent,
          PlanningComponent,
          ChooseClubComponent,
          AuthComponent,
          ClockComponent,
          CoachPickerComponent,
          AppBaseComponent,
          ConnectedUserComponent,
          HighlightsComponent,
          BookComponent,
          NotFoundComponent,
          ActiveBookingListComponent,
          ActiveBookingBadgeComponent,
          KeyboardDirective,
          WelcomeDialogComponent,
          InactivityProgressBarComponent,
          /*Pipes*/
          ApiassetPipe,
          TranslatePipe,
          DefaultAssetPipe,
          TimePipe,
          SprintfPipe,
          DisconnectedComponent,
          AppFooterComponent,
          CrashComponent,
          LangChangerComponent,
     ],
     imports: [
          BrowserModule,
          HttpClientModule,
          FormsModule,
          BrowserAnimationsModule,
          AppRoutingModule,
          ToastrModule.forRoot(),
          NgxSpinnerModule,
          MatDialogModule,
          NgScrollbarModule,
          ClickOutsideModule,
     ],
     providers: [
          WsService,
          NotLoggedGuard,
          LoggedRouteGuard,
          SessionService,
          SelectedClubService,
          DataBootstrapGuard,
          DataService,
          SessionPrepareService,
          ErrorDialogService,
          SpinnerMessageService,
          CrashMessageService,
          LogoutService,
          BootstrapSessionService,
          [{ provide: LOCALE_ID, useValue: window.app.lang.activatedLang }],
          // https://stackoverflow.com/a/50970853
          [
               {
                    provide: HTTP_INTERCEPTORS,
                    useClass: WsHttpInterceptor,
                    multi: true,
               },
          ],
          ...nonTvScreenService,
     ],
     bootstrap: [AppComponent],
})
export class AppModule {}
